import Vue from 'vue'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import ElementUI from 'element-ui'

import '@/styles/element-variables.scss'
import '@/styles/index.scss' // global css
// import '@/styles/app.scss' // 自定义全局 css

import App from '@/App'
import util from '@/utils'
import store from '@/store'
import router from '@/router'

import '@/icons' // icon
import '@/permission' // permission control

/**
 * 获取变量在数组中的索引位置
 *
 * @param {any} value 要查找的变量值
 * @param {String} key 如果是json数组，key则为json数据的字段名称
 * @param {Number} start 搜索开始位置，默认为 0
 */
Array.prototype.query = function(value, key = '', start = 0) {
  if (!this || !this.length || !value) return -1
  if (typeof this[0] === 'object') {
    for (let i = start; i < this.length; i++) {
      const item = this[i]
      if (item[key] === value) return i
    }
    return -1
  }
  return this.indexOf(value, start)
}

Date.prototype.format = function(format = 'yyyy-MM-dd') {
  if (!this) return ''
  if (!format) format = 'yyyy-MM-dd'
  const options = {
    'y+': this.getFullYear().toString(),
    'M+': (this.getMonth() + 1).toString(),
    'd+': this.getDate().toString(),
    'h+': this.getHours().toString(),
    'm+': this.getMinutes().toString(),
    's+': this.getSeconds().toString()
  }
  for (const key in options) {
    const result = new RegExp('(' + key + ')').exec(format)
    if (result) {
      format = format.replace(result[1], (result[1].length === 1) ? (options[key]) : (options[key].padStart(result[1].length, '0')))
    }
  }
  return format
}

Vue.use(ElementUI, { size: 'small' }) // set element-ui default size

Vue.config.productionTip = false
Vue.prototype.$util = util
Vue.filter('filterPrice', function(price) {
  return price ? util.formatNumber(price, 2) : ''
})
Vue.filter('filterInteger', function(price) {
  return price ? util.formatNumber(price) : ''
})
Vue.filter('filterDate', function(dateTime) {
  return dateTime ? util.formatDate(dateTime, 'yyyy-MM-dd') : ''
})
Vue.filter('filterTime', function(dateTime) {
  return dateTime ? util.formatDate(dateTime, 'hh:mm:ss') : ''
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
